<template>
  <c-btn
    :loading="isLoading"
    color="primary"
    variant="text"
    class="px-0"
    :height="32"
    @click="openTelegram()"
  >
    <template #default>
      <span>{{ $t('main.login_subscribe') }}</span>
      <v-icon size="16" class="ml-2"> $arrow-right </v-icon>
    </template>
  </c-btn>
</template>

<script>
  import { CBtn } from '@clickadilla/components/components'
  import { personalRepository } from '@/services/repository-factory'
  import handleErrors from '@/services/handleErrors'
  import gtmPush from '@/services/utils/gtm-push'

  export default {
    name: 'SubscribeTelegram',
    components: { CBtn },
    props: {
      gtmEvent: {
        type: String,
        required: true
      }
    },
    emits: ['subscribe'],
    data() {
      return {
        temporaryUrl: null,
        isLoading: false,
        timerId: null
      }
    },
    beforeUnmount() {
      clearTimeout(this.timerId)
    },
    methods: {
      async openTelegram() {
        gtmPush({ event: this.gtmEvent })
        if (!this.temporaryUrl) {
          await this.onTelegramAuth()
          this.timerId = setTimeout(() => {
            this.temporaryUrl = null
          }, 35000)
        }
        if (this.temporaryUrl) {
          window.open(this.temporaryUrl, '_blank')
          this.$emit('subscribe')
        }
      },
      async onTelegramAuth() {
        this.isLoading = true
        try {
          const response = await personalRepository.generateUrlTelegram()
          this.temporaryUrl = response.temporary_url
        } catch (error) {
          handleErrors(error)
        }
        this.isLoading = false
      }
    }
  }
</script>
